import moment from 'moment'
import CryptoJS from 'crypto-js'

var key = CryptoJS.enc.Latin1.parse('mmt20202mmt20202');
var iv = CryptoJS.enc.Latin1.parse('mmt20202mmt20202');

export function dateFormat(d, format) {
    return moment(d).format(format || 'YYYY-MM-DD');
}

export function list2map(list, key) {
    key = key || 'id';
    let map = {}, root = [];
    list = list || [];
    list.forEach((o, i) => {
        let k = '_' + (o[key] || '');
        map[k] = o;
    });
    return map;
}

export function list2mapTree(list, key, pkey) {
    let map = {}, root = [];
    key = key || 'id';
    pkey = pkey || 'parentId';
    list = list || [];
    list.forEach((o, i) => {
        let k = '_' + (o[pkey] || '');
        let ls = map[k] || [];
        ls.push(o);
        map[k] = ls;
    });
    list.forEach((o, i) => {
        let k = '_' + o[key];
        if (map[k]) {
            o.children = map[k];
        }
    })
    return map;
}

export function list2tree(list, key, pkey, sort) {
    let map = {}, root = [];
    key = key || 'id';
    pkey = pkey || 'parentId';
    list = list || [];
    list.forEach((o, i) => {
        let k = '_' + (o[pkey] || '@');
        let ls = map[k] || [];
        ls.push(o);
        map[k] = ls;
    });
    if (typeof (sort) == "function") {
        for (let _k in map) {
            map[_k].sort(sort);
        }
    }
    list.forEach((o, i) => {
        let k = '_' + o[key];
        if (map[k]) {
            o.children = map[k];
        }
    })
    return map['_@'];
}

//解密方法
export function Decrypt(word) {
    return CryptoJS.AES.decrypt(word, key, {iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.ZeroPadding})
        .toString(CryptoJS.enc.Utf8);
}

// 加密
export function Encrypt(data) {
    return CryptoJS.AES.encrypt(data, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.ZeroPadding
    }).toString();
}